import './PlanInProgressDoneTask.style.less'

// import { ITaskTemplate } from '../../../../../../../../TaskTemplate.interface'
import PlanTaskLayout from '../../Layouts/PlanTaskLayout'

interface Prop {
  data: any
}

export function PlanInProgressDoneTask(prop: Prop) {
  return <PlanTaskLayout data={prop.data} planLabel={`Plan Start`} />
}

export default PlanInProgressDoneTask
